const SQLITE_UTC = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/;
const EXECUTION_MILESTONE_FIELDS = [
  ['script_time', '脚本'],
  ['shooting_time', '拍摄'],
  ['first_draft_time', '初稿'],
  ['schedule_time', '档期'],
];

export function formatChinaDateTime(value) {
  const raw = String(value || '').trim();
  if (!raw) return '—';
  const normalized = SQLITE_UTC.test(raw) ? `${raw.replace(' ', 'T')}Z` : raw;
  const parsed = new Date(normalized);
  if (Number.isNaN(parsed.getTime())) return '—';
  const china = new Date(parsed.getTime() + 8 * 60 * 60 * 1000);
  const two = number => String(number).padStart(2, '0');
  return `${china.getUTCFullYear()}-${two(china.getUTCMonth() + 1)}-${two(china.getUTCDate())} ${two(china.getUTCHours())}:${two(china.getUTCMinutes())}:${two(china.getUTCSeconds())}`;
}

export function executionMilestones(order = {}) {
  return EXECUTION_MILESTONE_FIELDS.flatMap(([field, label]) => {
    const dateTime = String(order[field] || '').trim();
    const match = /^(\d{4})-(\d{2})-(\d{2})(?:T\d{2}:\d{2})?$/.exec(dateTime);
    return match ? [{ label, date: `${match[2]}-${match[3]}`, dateTime }] : [];
  });
}

export function recommendationOrderHistory(recommendation = {}) {
  const history = Array.isArray(recommendation.order_history) ? recommendation.order_history : [];
  const dates = history
    .map(item => String(item?.publish_date || '').trim())
    .filter(date => /^\d{4}-\d{2}-\d{2}$/.test(date))
    .sort((a, b) => a.localeCompare(b));
  const count = Math.max(Number(recommendation.order_count || 0), history.length);
  const missingCount = Math.max(0, history.length - dates.length);
  const missingText = missingCount ? `；${missingCount} 个旧订单未填写` : '';
  return {
    count,
    dates,
    missingCount,
    text: count
      ? `已有 ${count} 个订单，达人发布日期：${dates.length ? dates.join('、') : '日期暂缺'}${missingText}。请选择未使用的达人发布日期。`
      : '当前还没有历史订单，本次为第 1 个订单。',
  };
}
